/* ============================================================
   KIT MECHANICS BANNER — copiar cupom
   - Copia o código pro clipboard e dá feedback ("Copiado!")
   - Reinicializa no shopify:section:load (editor de tema)
   - Não bloqueante (carregado com defer); fallback sem Clipboard API
   ============================================================ */
(function () {
  var COPIED_MS = 3200;

  function fallbackCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {
      /* silencioso: sem clipboard disponível */
    }
  }

  function wire(btn) {
    if (btn.__kmbInit) return;
    btn.__kmbInit = true;

    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-code') || '';
      var status = btn.parentElement.querySelector('[data-kmb-status]');
      var copiedTxt = status ? status.getAttribute('data-copied') : '';
      var idleTxt = status ? status.getAttribute('data-idle') : '';

      function feedback() {
        btn.classList.add('is-copied');
        if (status && copiedTxt) {
          status.textContent = copiedTxt;
          status.classList.add('is-copied');
        }
        clearTimeout(btn.__kmbTimer);
        btn.__kmbTimer = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (status) {
            status.textContent = idleTxt;
            status.classList.remove('is-copied');
          }
        }, COPIED_MS);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(feedback).catch(function () {
          fallbackCopy(code);
          feedback();
        });
      } else {
        fallbackCopy(code);
        feedback();
      }
    });
  }

  function wireCta(link) {
    if (link.__kmbCta) return;
    link.__kmbCta = true;
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      // só intercepta âncoras internas (#id); links externos seguem normal
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var btns = scope.querySelectorAll('[data-kmb-copy]');
    for (var i = 0; i < btns.length; i++) wire(btns[i]);
    var ctas = scope.querySelectorAll('[data-kmb-cta]');
    for (var j = 0; j < ctas.length; j++) wireCta(ctas[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Editor de tema: re-render da section
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
